export default __webpack_public_path__ + "static/media/webviewreport.ddc0498e.svg";